import classNames from 'classnames';
import React from 'react';

import { Typography } from '@/components/atoms/Typography';

export interface Props {
  src: string;
  title?: string;
  color?: 'white' | 'black';
  bgClassName?: string;
}

export const ImageBlock = ({ src, title, color = 'black', bgClassName = 'bg-green border-green' }: Props) => {
  return (
    <div className="flex flex-col items-center">
      <div className={classNames('border md:w-20 md:h-20 w-14 h-14 rounded-full overflow-hidden', bgClassName)}>
        <img src={src} alt={title} width={200} draggable={false} height={200} className="md:p-4 p-2 w-full h-full object-contain" />
      </div>
      <div className="max-w-[200px]">
        <Typography variant="paragraph" align="center" color={color}>
          {title}
        </Typography>
      </div>
    </div>
  );
};
